import { SidebarProvider } from "@/components/ui/sidebar";

export function WorkspaceSkeleton() {
  return (
    <SidebarProvider className="h-full">
      {/* Left Sidebar Skeleton */}
      <aside className="flex h-full w-64 flex-col bg-theme-1">
        {/* Header */}
        <div className="p-4 h-[60px] flex items-center">
          <div className="h-8 w-full bg-theme-0 rounded-lg animate-pulse"></div>
        </div>

        {/* Navigation/Tabs */}
        {/* <div className="flex gap-2 p-4 h-[50px]">
          <div className="h-9 flex-1 bg-theme-0 rounded-lg animate-pulse"></div>
          <div className="h-9 flex-1 bg-theme-0 rounded-lg animate-pulse"></div>
        </div> */}

        {/* Content List */}
        <div className="flex-1 space-y-3 overflow-auto p-4">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="space-y-2 rounded-xl bg-theme-0/30 p-3">
              <div className="h-5 w-3/4 bg-theme-0 rounded-lg animate-pulse"></div>
              <div className="h-3 w-1/2 bg-theme-0 rounded-lg animate-pulse"></div>
            </div>
          ))}
        </div>
      </aside>

      {/* Main Content Area Skeleton */}
      <main className="flex flex-1 flex-col bg-theme-2">
        {/* Header */}
        <div className="flex items-center justify-between p-4 h-[60px]">
          <div className="space-y-2 flex-1">
            <div className="h-7 w-56 bg-theme-0 rounded-lg animate-pulse"></div>
          </div>
          <div className="h-9 w-28 bg-theme-0 rounded-lg animate-pulse"></div>
        </div>

        {/* Sub-header */}
        <div className="p-4 h-[50px] flex items-center">
          <div className="h-4 w-36 bg-theme-0 rounded-lg animate-pulse"></div>
        </div>

        {/* Chat Messages Area */}
        <div className="flex-1 space-y-6 overflow-auto p-6">
          {/* Message 1 */}
          <div className="flex gap-4">
            <div className="h-10 w-10 shrink-0 rounded-full bg-theme-0 animate-pulse"></div>
            <div className="flex-1 space-y-2.5">
              <div className="h-4 w-full max-w-2xl bg-theme-0 rounded-lg animate-pulse"></div>
              <div className="h-4 w-5/6 max-w-xl bg-theme-0 rounded-lg animate-pulse"></div>
              <div className="h-4 w-4/6 max-w-lg bg-theme-0 rounded-lg animate-pulse"></div>
            </div>
          </div>

          {/* Message 2 */}
          <div className="flex gap-4">
            <div className="h-10 w-10 shrink-0 rounded-full bg-theme-0 animate-pulse"></div>
            <div className="flex-1 space-y-2.5">
              <div className="h-4 w-full max-w-2xl bg-theme-0 rounded-lg animate-pulse"></div>
              <div className="h-4 w-3/4 max-w-xl bg-theme-0 rounded-lg animate-pulse"></div>
            </div>
          </div>

          {/* Message 3 */}
          <div className="flex gap-4">
            <div className="h-10 w-10 shrink-0 rounded-full bg-theme-0 animate-pulse"></div>
            <div className="flex-1 space-y-2.5">
              <div className="h-4 w-full max-w-2xl bg-theme-0 rounded-lg animate-pulse"></div>
              <div className="h-4 w-4/5 max-w-xl bg-theme-0 rounded-lg animate-pulse"></div>
              <div className="h-4 w-2/3 max-w-lg bg-theme-0 rounded-lg animate-pulse"></div>
            </div>
          </div>
        </div>

        {/* Input Area */}
        <div className="bg-theme-2 p-4">
          <div className="space-y-3">
            <div className="h-24 w-full bg-theme-0 rounded-xl animate-pulse"></div>
            <div className="flex items-center justify-between">
              <div className="flex gap-2">
                <div className="h-9 w-9 bg-theme-0 rounded-lg animate-pulse"></div>
                <div className="h-9 w-9 bg-theme-0 rounded-lg animate-pulse"></div>
              </div>
              <div className="h-9 w-24 bg-theme-0 rounded-lg animate-pulse"></div>
            </div>
          </div>
        </div>
      </main>

      {/* Right Sidebar Skeleton */}
      <aside className="flex h-full w-80 flex-col bg-theme-1">
        {/* Header */}
        <div className="p-4 h-[60px] flex items-center">
          <div className="h-6 w-40 bg-theme-0 rounded-lg animate-pulse"></div>
        </div>

        {/* Content */}
        <div className="flex-1 space-y-4 overflow-auto p-4">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="space-y-3 rounded-xl bg-theme-0/20 p-4">
              <div className="flex items-start justify-between">
                <div className="h-5 w-2/3 bg-theme-0 rounded-lg animate-pulse"></div>
                <div className="h-5 w-5 rounded-full bg-theme-0 animate-pulse"></div>
              </div>
              {/* <div className="h-3.5 w-4/5 bg-theme-0 rounded-lg animate-pulse"></div> */}
              {/* <div className="h-3.5 w-3/5 bg-theme-0 rounded-lg animate-pulse"></div> */}
              {/* <div className="flex gap-2 pt-1">
                <div className="h-6 w-16 bg-theme-0 rounded-full animate-pulse"></div>
                <div className="h-6 w-20 bg-theme-0 rounded-full animate-pulse"></div>
              </div> */}
            </div>
          ))}
        </div>
      </aside>
    </SidebarProvider>
  );
}
